import React, { useState, useEffect } from 'react';
// import axios from 'axios'; // removido
import api from '../../api/axiosConfig'; // adicionado
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { Table, Tabs } from 'antd';
import { ComposedChart, Line, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import '../Css/AnaliseComponente.css';
import { 
  LineChartOutlined, 
  BarChartOutlined, 
  PieChartOutlined, 
  AreaChartOutlined, 
  BulbOutlined, 
  MenuOutlined 
} from '@ant-design/icons';

const AnaliseMisticos = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [frequeData, setFrequeData] = useState([]);
  const [dezenData, setDezenaData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeKey, setActiveKey] = useState("1");

  // Alerta de carregamento
  useEffect(() => {
    if (loading) {
      Swal.fire({
        title: 'Carregando...',
        text: 'Estamos processando as informações.',
        icon: 'info',
        showConfirmButton: false,
        willOpen: () => {
          Swal.showLoading();
        }
      });
    }
  }, [loading]);

  // Carregar os dados da API
  useEffect(() => {
    api.get(`/estatistica_atraso_rep_misticos`)
      .then(response => {
        setData(response.data.data || []);
        setLoading(false);
      })
      .catch(error => {
        console.error("Erro ao buscar os dados de Analise:", error);
        setLoading(false);
        Swal.fire({
          title: 'Erro!',
          text: 'Não foi possível carregar os dados de Analise.',
          icon: 'error',
          confirmButtonText: 'OK'
        });
      });

    api.get(`/freque_misticos`)
      .then(response => {
        setFrequeData(response.data || []);
      })
      .catch(error => {
        console.error("Erro ao buscar os dados de frequência:", error);
        setFrequeData([]);
        Swal.fire({
          title: 'Erro!',
          text: 'Não foi possível carregar os dados de frequência.',
          icon: 'error',
          confirmButtonText: 'OK'
        });
      });

    api.get(`/estatistica_atraso_misticos`)
      .then(response => {
        setDezenaData(response.data.data || []);
      })
      .catch(error => {
        console.error("Erro ao buscar os dados de Dezenas sorteadas:", error);
        setDezenaData([]);
        Swal.fire({
          title: 'Erro!',
          text: 'Não foi possível carregar os dados de Dezenas sorteadas.',
          icon: 'error',
          confirmButtonText: 'OK'
        });
      });
  }, []);

  // Fechar o alerta de carregamento depois que os dados forem carregados
  useEffect(() => {
    if (!loading) {
      setTimeout(() => {
        Swal.close();
      }, 1500);
    }
  }, [loading]);

  const onTabChange = (key) => {
    setActiveKey(key);
  };

  const columns = [
    { title: 'Dezenas', dataIndex: 'repetido', key: 'repetido' },
    { title: 'Quantidade', dataIndex: 'qte', key: 'qte' },
    { title: '%', dataIndex: 'percente', key: 'percente', render: (text) => `${text} %` },
    { title: 'Média Sorteio', dataIndex: 'mdSorteio', key: 'mdSorteio' },
    { title: 'Atrasados', dataIndex: 'atrasados', key: 'atrasados', render: (text, record) => (
        <span className={record.atrasados > record.mdSorteio ? 'highlight-high' : ''}>{text}</span>
      )},
    { title: 'Status Jogos', dataIndex: 'pj', key: 'pj', render: (text) => (
        <span className={text === 'Melhor Opção!' ? 'melhor-opcao' : ''}>{text}</span>
      )} 
  ];

  const frequeColumns = [
    { title: 'Dezenas', dataIndex: 'dezenas', key: 'dezenas' },
    { title: 'Quantidade', dataIndex: 'qte', key: 'qte' },
    { title: '%', dataIndex: 'percente', key: 'percente', render: (text) => `${text} %` },
    { title: 'Frequência', dataIndex: 'freqAcu', key: 'freqAcu',  render: (text) => `${text} - JG` },
    { title: 'Frequência AC', dataIndex: 'freqAcmlda', key: 'freqAcmlda', render: (text) => `${text} %` },
  ];

  const dezenaColumns = [
    { title: 'Numeros', dataIndex: 'dezenas', key: 'dezenas' },
    { title: 'Quantidade', dataIndex: 'qte', key: 'qte' },
    { title: '%', dataIndex: 'percente', key: 'percente', render: (text) => `${text} %` },
    { title: 'Média Sorteio', dataIndex: 'mdSorteio', key: 'mdSorteio' },
    { title: 'Atrasados', dataIndex: 'atrasados', key: 'atrasados', render: (text, record) => (
      <span className={record.atrasados > record.mdSorteio ? 'highlight-high' : ''}>{text}</span>
      )},
    { title: 'Status Jogos', dataIndex: 'pj', key: 'pj', render: (text) => (
        <span className={text === 'Melhor Opção!' ? 'melhor-opcao' : ''}>{text}</span>
      )} 
  ];

  // Mapeamento para os gráficos
  const chartData = data.map(item => ({
    name: `${item.repetido} - Dz`,
    quantidade: item.qte,
    percentual: item.percente,
  }));

  const frequeChartData = frequeData.map(item => ({
    name: `${item.dezenas} - Dz`,
    quantidade: item.qte,
    percentual: item.percente,
    frequencia: item.freqAcu,
    frequenciaAc: item.freqAcmlda,
  }));

  const dezenachartData = dezenData.map(item => ({
    name: `Nu - ${item.dezenas}`,
    quantidade: item.qte,
    percentual: item.percente,
  }));

  const tabsItems = [
    {
      label: <LineChartOutlined className="icon-size-24" />,
      key: "1",
      children: (
        <div>
          <h2><span>Análise - Místicos</span></h2>
          <ResponsiveContainer width="100%" height={400}>
            <ComposedChart width={500} height={400} data={chartData}>
              <CartesianGrid stroke="#f5f5f5" />
              <XAxis dataKey="name" scale="band" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar dataKey="quantidade" barSize={50} fill="#007AA2" />
              <Line type="monotone" dataKey="percentual" stroke="#ff7300" />
            </ComposedChart>
          </ResponsiveContainer>
          <div className="table-container">
            <Table columns={columns} dataSource={data} loading={loading} rowKey="id" pagination={false} />
          </div>
        </div>
      )
    },
    {
      label: <BarChartOutlined className="icon-size-24" />,
      key: "2",
      children: (
        <div>
          <h2><span>Frequência - Místicos</span></h2>
          <ResponsiveContainer width="100%" height={400}>
            <ComposedChart width={500} height={400} data={frequeChartData}>
              <CartesianGrid stroke="#f5f5f5" />
              <XAxis dataKey="name" scale="band" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar dataKey="quantidade" stackId="a" barSize={50} fill="#004B57" />
              <Bar dataKey="percentual" stackId="a" barSize={50} fill="#ff7300" />
              <Bar dataKey="frequencia" stackId="a" barSize={50} fill="#007AA2" />
              <Bar dataKey="frequenciaAc" stackId="a" barSize={50} fill="#008DC0" />
            </ComposedChart>
          </ResponsiveContainer>
          <div className="table-container">
            <Table columns={frequeColumns} dataSource={frequeData} loading={loading} rowKey="id" pagination={false} />
          </div>
        </div>
      )
    },
    {
      label: <AreaChartOutlined className="icon-size-24" />,
      key: "3",
      children: (
        <div>
          <h2><span>Dezenas - Místicos</span></h2>
          <ResponsiveContainer width="100%" height={400}>
            <ComposedChart width={500} height={400} data={dezenachartData}>
              <CartesianGrid stroke="#f5f5f5" />
              <XAxis dataKey="name" scale="band" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar dataKey="quantidade" barSize={50} fill="#007AA2" />
              <Line type="monotone" dataKey="percentual" stroke="#ff7300" />
            </ComposedChart>
          </ResponsiveContainer>
          <div className="table-container">
            <Table columns={dezenaColumns} dataSource={dezenData} loading={loading} rowKey="id" pagination={false} />
          </div>
        </div>
      )
    },
    {
      label: <BulbOutlined className="icon-size-24" />,
      key: "4",
      children: (
        <div>
          <h2><span>Ideias Dz - Místicos</span></h2>
        </div>
      )
    },
    {
      label: <MenuOutlined className="icon-size-24" onClick={() => navigate("/dashboard")} />,
      key: "5",      
    }
  ];

  return (
    <div className="analysis-container">
      <Tabs
        activeKey={activeKey}
        onChange={onTabChange}
        tabPosition={"right"}
        items={tabsItems}
      />
    </div>
  );
};

export default AnaliseMisticos;
